import { render, staticRenderFns } from "./PartnerReferralCodesModal.vue?vue&type=template&id=98a52b9e&scoped=true"
import script from "./PartnerReferralCodesModal.vue?vue&type=script&lang=js"
export * from "./PartnerReferralCodesModal.vue?vue&type=script&lang=js"
import style0 from "./PartnerReferralCodesModal.vue?vue&type=style&index=0&id=98a52b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a52b9e",
  null
  
)

export default component.exports